const trackingAddress = "https://api2.idha.com.br:3013"

export default trackingAddress